import { Dropdown } from "semantic-ui-react";

type ConfirmReasonType = {
  id: number;
  name: string;
};

type ConfirmReasonDropdownOptionType = {
  key: number;
  text: string;
  value: number;
};

export const CUSTOM_REASON = -1;

type CustomReasonsProps = {
  confirmReasons?: ConfirmReasonType[];
  handleOnChange: (value: number) => void;
  allowCustomReason?: boolean;
  placeholderText?: string;
};

export const CustomReasons = ({ handleOnChange, confirmReasons, allowCustomReason, placeholderText }: CustomReasonsProps) => {
  let options: ConfirmReasonDropdownOptionType[] = [];
  if (confirmReasons) {
    options = confirmReasons.map((reason: ConfirmReasonType) => ({
      key: reason.id,
      text: reason.name,
      value: reason.id
    }));

    if (allowCustomReason) options.push({ key: CUSTOM_REASON, text: "Other reason", value: CUSTOM_REASON });
  }

  return (
    <Dropdown
      placeholder={placeholderText || "Pick reason"}
      selection
      options={options}
      onChange={(_, { value }) => {
        handleOnChange(value as number);
      }}
    />
  );
};
